class CodexThemeSignatureRuntime {
  constructor(signatureData) {
    this.signatureData = signatureData;
  }

  mount() {
    document.documentElement.setAttribute("data-codex-code-runtime", this.signatureData.signature);
    document.documentElement.setAttribute("data-codex-code-runtime-family", this.signatureData.family);
    document.documentElement.setAttribute("data-codex-code-runtime-history", "r" + this.signatureData.historyRevision);
    document.documentElement.style.setProperty("--codex-code-runtime-token", "507");
    document.documentElement.style.setProperty("--codex-code-runtime-family-token", "751");
    document.documentElement.style.setProperty("--codex-code-runtime-history-revision", "2");
    window.__CODEX_THEME_SIGNATURE__ = this.signatureData;
  }
}

const codexThemeSignatureRuntime = new CodexThemeSignatureRuntime({"signature": "rzvjt0-y3", "family": "crazyaarons", "historyRevision": 2, "styleKind": "anchor"});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => codexThemeSignatureRuntime.mount(), { once: true });
} else {
  codexThemeSignatureRuntime.mount();
}
